module.exports = __webpack_public_path__ + "img/video1-bg.531bfd93.png";